import { InputHTMLAttributes } from 'react';
import { SearchIcon, CancelIcon } from "../../utils/iconFactory"
import { classNames } from "../../utils/utils"

interface CustomInputProps extends InputHTMLAttributes<HTMLInputElement> {
  customAction?: () => void;
}

export function SearchInput({ customAction, value, className, ...props }: CustomInputProps) {
  return (
    <div className="relative"> 
      <input type="text"
        className={classNames("h-12 w-full pl-10 pr-10 py-2 rounded-[12px] bg-backgroundWhite",
          "border border-gray100 text-style-body2 text-textMain",
          "placeholder-gray100",
          "hover:border-primaryActionAltHover",
          "active:border-textMain active:ring-0 active:outline-none focus:border-textMain focus:ring-0 focus:outline-none",
          "disabled:bg-gray0 disabled:border-gray10 disabled:gray40",
        className)}
        value={value}
        {...props}
        /> 
      <div className="absolute top-0 translate-x-3 translate-y-3 left-0">
        <SearchIcon className="h-6 w-6 text-primaryActionAltHover fill-current" />
      </div>
      {
        value !== "" && (
          <button className="absolute top-0 -translate-x-3 translate-y-3 right-0" onClick={customAction}>
            <CancelIcon className="h-6 w-6 text-gray150 fill-current" />
          </button>
        )
      }
  </div> 
  )
}

export function CustomInput({ customAction, value, className, ...props }: CustomInputProps) {
  return (
    <div className="relative"> 
      <input type="text"
        className={classNames("h-12 w-full pl-3 pr-10 py-2 rounded-[12px] bg-backgroundWhite",
          "border border-gray100 text-style-body2 text-textMain",
          "placeholder-gray100",
          "hover:border-primaryActionAltHover",
          "active:border-textMain active:ring-0 active:outline-none focus:border-textMain focus:ring-0 focus:outline-none",
          "disabled:bg-gray0 disabled:border-gray10 disabled:gray40",
        className)}
        value={value}
        {...props}
        /> 
      {
        value !== "" && (
          <button className="absolute top-0 -translate-x-3 translate-y-3 right-0" onClick={customAction}>
            <CancelIcon className="h-6 w-6 text-gray150 fill-current" />
          </button>
        )
      }
  </div> 
  )
}